(function () {
  'use strict';

/* Tabela oficial de circunferencia — aro: cm */
  var CIRCUMFERENCE = [
    [10, 5.0], [11, 5.1], [12, 5.2], [13, 5.3], [14, 5.4], [15, 5.5],
    [16, 5.6], [17, 5.7], [18, 5.8], [19, 5.9], [20, 6.0], [21, 6.1],
    [22, 6.2], [23, 6.3], [24, 6.4], [25, 6.5], [26, 6.6], [27, 6.7],
    [28, 6.8], [29, 6.9], [30, 7.0], [31, 7.1], [32, 7.2], [33, 7.3]
  ];

  var DIAMETER = CIRCUMFERENCE.map(function (entry) { return [entry[0], entry[1] / Math.PI]; });

  /* 1 mm = 96/25.4 px CSS. Ponto de partida antes da calibracao. */
  var BASE_PPMM = 96 / 25.4;
  var CARD_W_MM = 53.98; /* borda curta do cartao ISO/IEC 7810 ID-1 */
  var CARD_H_MM = 85.6;  /* borda longa */
  var STORAGE_KEY = 'ga-ring-sizer-ppmm-v2';

  var TOL_DIAMETER = 0.03; /* cm — margem realista de medicao caseira */
  var TOL_CIRC = 0.05;

  function fmt(cm) {
    return cm.toFixed(2).replace('.', ',');
  }

  function readStoredScale() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var n = parseFloat(raw);
      return isFinite(n) && n > 0.3 && n < 4 ? n : null;
    } catch (e) {
      return null;
    }
  }

  function writeStoredScale(scale) {
    try {
      window.localStorage.setItem(STORAGE_KEY, String(scale));
    } catch (e) {
      /* modo privado ou storage bloqueado: segue sem lembrar */
    }
  }

  /* Acha o aro mais proximo. Empate resolve para o maior. */
  function nearest(table, value) {
    var bestIndex = 0;
    var bestDist = Infinity;
    for (var i = 0; i < table.length; i++) {
      var dist = Math.abs(table[i][1] - value);
      if (dist <= bestDist + 1e-9) {
        bestDist = dist;
        bestIndex = i;
      }
    }
    return { index: bestIndex, aro: table[bestIndex][0], value: table[bestIndex][1], dist: bestDist };
  }

  function alternatives(table, value, bestAro, tol) {
    var out = [];
    for (var i = 0; i < table.length; i++) {
      if (table[i][0] === bestAro) continue;
      if (Math.abs(table[i][1] - value) <= tol) out.push(table[i][0]);
    }
    return out;
  }

  function init(root) {
    if (!root || root.dataset.gaReady === 'true') return;
    root.dataset.gaReady = 'true';

    var q = function (sel) { return root.querySelector(sel); };
    var qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    var state = {
      scale: readStoredScale() || 1,
      calibrated: readStoredScale() !== null,
      diameterCm: 1.75,
      circCm: 5.8,
      aro: null
    };

    var ppmm = function () { return BASE_PPMM * state.scale; };

    /* ---------------- abas de metodo ---------------- */

    var methodTabs = qa('[data-ga-method]');
    var methodPanels = qa('[data-ga-panel]');

    function selectMethod(id) {
      methodTabs.forEach(function (tab) {
        tab.setAttribute('aria-selected', String(tab.dataset.gaMethod === id));
      });
      methodPanels.forEach(function (panel) {
        panel.hidden = panel.dataset.gaPanel !== id;
      });
      pauseVideosOutside(id);
      if (id !== '1') syncTool();
    }

    methodTabs.forEach(function (tab) {
      tab.addEventListener('click', function () { selectMethod(tab.dataset.gaMethod); });
    });

    /* ---------------- calibracao ---------------- */

    var calibToggles = qa('[data-ga-calib-toggle]');
    var calibBodies = qa('[data-ga-calib-body]');
    var calibCards = qa('[data-ga-calib-card]');
    var calibRanges = qa('[data-ga-calib-range]');
    var calibStatuses = qa('[data-ga-calib-status]');

    function paintCalibration() {
      var w = CARD_W_MM * ppmm();
      var h = CARD_H_MM * ppmm();
      calibCards.forEach(function (card) {
        card.style.width = w.toFixed(1) + 'px';
        card.style.height = h.toFixed(1) + 'px';
      });
      calibRanges.forEach(function (range) {
        if (parseFloat(range.value) !== state.scale) range.value = String(state.scale);
      });
      calibStatuses.forEach(function (status) {
        status.dataset.state = state.calibrated ? 'ok' : 'idle';
        status.textContent = state.calibrated ? 'Tela calibrada' : 'Tela não calibrada';
      });
      /* Instrumento travado enquanto não houver calibração: sem ela o
         desenho sai até 37% menor que o real num celular, e a pessoa
         recebe uma numeração bem acima da dela. Digitar a medida à mão
         continua liberado, porque não depende da escala da tela. */
      qa('[data-ga-lock]').forEach(function (lock) {
        lock.hidden = state.calibrated;
      });
    }

    function openCalibration(scope) {
      calibToggles.forEach(function (toggle, i) {
        var body = calibBodies[i];
        if (!body) return;
        if (scope && !scope.contains(toggle)) return;
        body.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
      });
    }

    calibToggles.forEach(function (toggle, i) {
      toggle.addEventListener('click', function () {
        var body = calibBodies[i];
        if (!body) return;
        var open = body.hidden;
        body.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
      });
    });

    qa('[data-ga-calib-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = state.scale + parseFloat(btn.dataset.gaCalibStep);
        state.scale = Math.min(2.2, Math.max(0.55, next));
        state.calibrated = true;
        writeStoredScale(state.scale);
        paintCalibration();
        paintGauge();
        buildRuler();
        paintRuler();
      });
    });

    qa('[data-ga-lock-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.closest('[data-ga-panel]') || root;
        openCalibration(panel);
        var range = panel.querySelector('[data-ga-calib-range]');
        if (range) {
          range.scrollIntoView({ behavior: 'smooth', block: 'center' });
          range.focus();
        }
      });
    });

    calibRanges.forEach(function (range) {
      range.addEventListener('input', function () {
        state.scale = parseFloat(range.value);
        state.calibrated = true;
        writeStoredScale(state.scale);
        paintCalibration();
        paintGauge();
        buildRuler();
        paintRuler();
      });
    });

    /* ---------------- gabarito circular (metodo 2) ---------------- */

    var gaugeRing = q('[data-ga-gauge-ring]');
    var gaugeRange = q('[data-ga-gauge-range]');
    var gaugeValue = q('[data-ga-gauge-value]');
    var diameterInput = q('[data-ga-input-diameter]');

    function paintGauge() {
      if (!gaugeRing) return;
      var px = state.diameterCm * 10 * ppmm();
      gaugeRing.style.width = px.toFixed(1) + 'px';
      gaugeRing.style.height = px.toFixed(1) + 'px';
      if (gaugeValue) gaugeValue.textContent = fmt(state.diameterCm);
      if (gaugeRange && parseFloat(gaugeRange.value) !== state.diameterCm) {
        gaugeRange.value = state.diameterCm.toFixed(2);
      }
      gaugeRing.setAttribute('aria-valuenow', state.diameterCm.toFixed(2));
    }

    function setDiameter(cm, silent) {
      state.diameterCm = Math.min(2.4, Math.max(1.4, Math.round(cm * 100) / 100));
      paintGauge();
      if (!silent) resolveDiameter();
    }

    function resolveDiameter() {
      var hit = nearest(DIAMETER, state.diameterCm);
      var alts = alternatives(DIAMETER, state.diameterCm, hit.aro, TOL_DIAMETER);
      showResult({
        aro: hit.aro,
        alts: alts,
        source: 'diametro',
        measured: state.diameterCm,
        table: hit.value,
        dist: hit.dist
      });
    }

    if (gaugeRange) {
      gaugeRange.addEventListener('input', function () {
        setDiameter(parseFloat(gaugeRange.value));
      });
    }

    qa('[data-ga-gauge-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setDiameter(state.diameterCm + parseFloat(btn.dataset.gaGaugeStep));
      });
    });

    /* arrastar direto sobre o circulo redimensiona o gabarito */
    if (gaugeRing) {
      var dragging = false;
      var startX = 0;
      var startCm = 0;
      gaugeRing.addEventListener('pointerdown', function (ev) {
        dragging = true;
        startX = ev.clientX;
        startCm = state.diameterCm;
        gaugeRing.setPointerCapture(ev.pointerId);
      });
      gaugeRing.addEventListener('pointermove', function (ev) {
        if (!dragging) return;
        var deltaMm = ((ev.clientX - startX) * 2) / ppmm();
        setDiameter(startCm + deltaMm / 10);
      });
      var stop = function () { dragging = false; };
      gaugeRing.addEventListener('pointerup', stop);
      gaugeRing.addEventListener('pointercancel', stop);
      gaugeRing.addEventListener('keydown', function (ev) {
        var map = { ArrowRight: 0.01, ArrowUp: 0.01, ArrowLeft: -0.01, ArrowDown: -0.01 };
        if (map[ev.key] === undefined) return;
        ev.preventDefault();
        setDiameter(state.diameterCm + map[ev.key]);
      });
    }

    if (diameterInput) {
      diameterInput.addEventListener('change', function () {
        var v = parseFloat(String(diameterInput.value).replace(',', '.'));
        if (!isFinite(v)) return;
        if (v > 10) v = v / 10; /* digitou em mm */
        setDiameter(v);
      });
    }

    /* ---------------- regua na tela (metodo 3) ---------------- */

    var rulerScroll = q('[data-ga-ruler-scroll]');
    var rulerTrack = q('[data-ga-ruler-track]');
    var rulerCursor = q('[data-ga-ruler-cursor]');
    var rulerRange = q('[data-ga-ruler-range]');
    var rulerValue = q('[data-ga-ruler-value]');
    var circInput = q('[data-ga-input-circ]');
    var RULER_MAX_MM = 82;

    function buildRuler() {
      if (!rulerTrack) return;
      var scale = ppmm();
      rulerTrack.style.width = (RULER_MAX_MM * scale + 40).toFixed(1) + 'px';
      var marks = rulerTrack.querySelector('[data-ga-ruler-marks]');
      if (!marks) return;
      var html = '';
      for (var mm = 0; mm <= RULER_MAX_MM; mm++) {
        var left = (20 + mm * scale).toFixed(2);
        var size = mm % 10 === 0 ? 'cm' : (mm % 5 === 0 ? 'half' : 'mm');
        html += '<i class="ga-ruler__tick" data-size="' + size + '" style="left:' + left + 'px"></i>';
        if (mm % 10 === 0) {
          html += '<b class="ga-ruler__label" style="left:' + left + 'px">' + (mm / 10) + '</b>';
        }
      }
      marks.innerHTML = html;
    }

    function paintRuler() {
      if (!rulerCursor) return;
      var left = 20 + state.circCm * 10 * ppmm();
      rulerCursor.style.left = left.toFixed(1) + 'px';
      if (rulerValue) rulerValue.textContent = fmt(state.circCm);
      if (rulerRange && parseFloat(rulerRange.value) !== state.circCm) {
        rulerRange.value = state.circCm.toFixed(2);
      }
      /* so rola quando o cursor sai mesmo da area visivel: assim o zero
         da regua continua a vista sempre que couber. */
      if (rulerScroll) {
        var view = rulerScroll.clientWidth;
        if (left > rulerScroll.scrollLeft + view - 24 || left < rulerScroll.scrollLeft + 24) {
          rulerScroll.scrollLeft = Math.max(0, left - view * 0.62);
        }
      }
    }

    function setCirc(cm, silent) {
      state.circCm = Math.min(8.2, Math.max(4.4, Math.round(cm * 100) / 100));
      paintRuler();
      if (!silent) resolveCirc();
    }

    function resolveCirc() {
      var hit = nearest(CIRCUMFERENCE, state.circCm);
      var alts = alternatives(CIRCUMFERENCE, state.circCm, hit.aro, TOL_CIRC);
      showResult({
        aro: hit.aro,
        alts: alts,
        source: 'circunferencia',
        measured: state.circCm,
        table: hit.value,
        dist: hit.dist
      });
    }

    if (rulerRange) {
      rulerRange.addEventListener('input', function () {
        setCirc(parseFloat(rulerRange.value));
      });
    }

    qa('[data-ga-ruler-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setCirc(state.circCm + parseFloat(btn.dataset.gaRulerStep));
      });
    });

    if (rulerCursor) {
      var rDrag = false;
      rulerCursor.addEventListener('pointerdown', function (ev) {
        rDrag = true;
        rulerCursor.setPointerCapture(ev.pointerId);
      });
      rulerCursor.addEventListener('pointermove', function (ev) {
        if (!rDrag || !rulerTrack) return;
        var rect = rulerTrack.getBoundingClientRect();
        var mm = (ev.clientX - rect.left - 20) / ppmm();
        setCirc(mm / 10);
      });
      var rStop = function () { rDrag = false; };
      rulerCursor.addEventListener('pointerup', rStop);
      rulerCursor.addEventListener('pointercancel', rStop);
    }

    if (circInput) {
      circInput.addEventListener('change', function () {
        var v = parseFloat(String(circInput.value).replace(',', '.'));
        if (!isFinite(v)) return;
        if (v > 20) v = v / 10; /* digitou em mm */
        setCirc(v);
      });
    }

    /* alternancia regua x digitar */
    qa('[data-ga-switch]').forEach(function (group) {
      var buttons = Array.prototype.slice.call(group.querySelectorAll('button'));
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          buttons.forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
          var scope = group.closest('[data-ga-panel]') || root;
          qa('[data-ga-view]').forEach(function (view) {
            if (!scope.contains(view)) return;
            view.hidden = view.dataset.gaView !== btn.dataset.gaSwitchTarget;
          });
          syncTool();
        });
      });
    });

    /* ---------------- vídeo demonstrativo ---------------- */

    /* A trilha de áudio do clipe é silêncio digital e todo o texto está
       queimado na imagem, então rodar sem som não perde informação. */
    var videoFrames = qa('[data-ga-video]');

    function pauseVideosOutside(panelId) {
      videoFrames.forEach(function (frame) {
        var media = frame.querySelector('video');
        if (!media) return;
        var panel = frame.closest('[data-ga-panel]');
        if (panel && panel.dataset.gaPanel !== panelId && !media.paused) media.pause();
      });
    }

    videoFrames.forEach(function (frame) {
      var media = frame.querySelector('video');
      if (!media) return;

      if (frame.dataset.gaVideo === 'auto') {
        media.muted = true;
        media.loop = true;
        media.playsInline = true;
        media.setAttribute('playsinline', '');
        var autoCover = frame.querySelector('[data-ga-video-play]');
        if (autoCover) autoCover.hidden = true;

        if (typeof window.IntersectionObserver === 'function') {
          new window.IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                var playing = media.play();
                if (playing && playing.catch) playing.catch(function () {});
              } else if (!media.paused) {
                media.pause();
              }
            });
          }, { threshold: 0.35 }).observe(media);
        }
        return;
      }

      var cover = frame.querySelector('[data-ga-video-play]');
      if (!cover) return;
      cover.addEventListener('click', function () {
        cover.hidden = true;
        media.controls = true;
        media.playsInline = true;
        var playing = media.play();
        if (playing && playing.catch) {
          playing.catch(function () {
            /* autoplay bloqueado ou codec recusado: devolve a capa
               para a pessoa tentar pelos controles nativos. */
            cover.hidden = false;
          });
        }
      });
    });

    /* ---------------- resultado ---------------- */

    var result = q('[data-ga-result]');
    var resultSize = q('[data-ga-result-size]');
    var resultLead = q('[data-ga-result-lead]');
    var resultSpecs = q('[data-ga-result-specs]');
    var resultAlt = q('[data-ga-result-alt]');
    var resultCta = q('[data-ga-result-cta]');
    var ctaTemplate = root.dataset.gaCta || '';

    function showResult(data) {
      state.aro = data.aro;
      if (!result) return;
      result.hidden = false;

      if (resultSize) resultSize.textContent = String(data.aro);

      var dRow = DIAMETER.filter(function (r) { return r[0] === data.aro; })[0];
      var cRow = CIRCUMFERENCE.filter(function (r) { return r[0] === data.aro; })[0];

      if (resultSpecs) {
        resultSpecs.innerHTML =
          '<li>Diâmetro interno <b>' + fmt(dRow[1]) + ' cm</b></li>' +
          '<li>Circunferência <b>' + fmt(cRow[1]) + ' cm</b></li>' +
          '<li>Sua medida <b>' + fmt(data.measured) + ' cm</b></li>';
      }

      if (resultLead) {
        if (data.source === 'diametro') {
          resultLead.textContent = 'Pelo diâmetro interno que você mediu, o aro correspondente na nossa tabela é o ' + data.aro + '.';
        } else if (data.source === 'circunferencia') {
          resultLead.textContent = 'Pela circunferência que você mediu, o aro correspondente na nossa tabela é o ' + data.aro + '.';
        } else {
          resultLead.textContent = 'Você selecionou o aro ' + data.aro + ' direto na tabela.';
        }
      }

      if (resultAlt) {
        if (data.alts && data.alts.length) {
          resultAlt.hidden = false;
          resultAlt.innerHTML = 'Sua medida também fica muito próxima do aro <b>'
            + data.alts.join('</b> e do aro <b>') + '</b>. '
            + 'A diferença entre eles está abaixo do que uma medição caseira consegue distinguir. '
            + 'Na dúvida, escolha o maior: o anel precisa passar pela articulação.';
        } else if (data.dist > 0.02) {
          resultAlt.hidden = false;
          resultAlt.innerHTML = 'Sua medida ficou entre duas numerações. '
            + 'Indicamos o aro <b>' + data.aro + '</b> por ser o mais próximo. '
            + 'Repita a medição antes de decidir.';
        } else {
          resultAlt.hidden = true;
        }
      }

      if (resultCta && ctaTemplate) {
        resultCta.href = ctaTemplate;
        resultCta.hidden = false;
      }

      paintTables();
    }

    qa('[data-ga-submit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var kind = btn.dataset.gaSubmit;
        var input = kind === 'diameter' ? diameterInput : circInput;
        if (!input) return;
        var v = parseFloat(String(input.value).replace(',', '.'));
        if (!isFinite(v)) {
          input.focus();
          return;
        }
        if (kind === 'diameter') {
          setDiameter(v > 10 ? v / 10 : v);
        } else {
          setCirc(v > 20 ? v / 10 : v);
        }
        if (result) result.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    /* ---------------- tabelas ---------------- */

    var tableTabs = qa('[data-ga-table-tab]');
    var tablePanels = qa('[data-ga-table-panel]');

    tableTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tableTabs.forEach(function (t) {
          t.setAttribute('aria-selected', String(t === tab));
        });
        tablePanels.forEach(function (panel) {
          panel.hidden = panel.dataset.gaTablePanel !== tab.dataset.gaTableTab;
        });
      });
    });

    function paintTables() {
      qa('tr[data-aro]').forEach(function (row) {
        var aro = parseInt(row.dataset.aro, 10);
        row.dataset.active = String(aro === state.aro);
        row.dataset.near = String(state.aro !== null && Math.abs(aro - state.aro) === 1);
      });
    }

    qa('[data-ga-pick-aro]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var aro = parseInt(btn.dataset.gaPickAro, 10);
        var dRow = DIAMETER.filter(function (r) { return r[0] === aro; })[0];
        setDiameter(dRow[1], true);
        var cRow = CIRCUMFERENCE.filter(function (r) { return r[0] === aro; })[0];
        setCirc(cRow[1], true);
        showResult({ aro: aro, alts: [], source: 'tabela', measured: dRow[1], table: dRow[1], dist: 0 });
        if (result) result.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    /* ---------------- perguntas frequentes ---------------- */

    qa('[data-ga-faq]').forEach(function (item) {
      var button = item.querySelector('.ga-faq__q');
      if (!button) return;
      button.addEventListener('click', function () {
        var open = item.dataset.open === 'true';
        item.dataset.open = String(!open);
        button.setAttribute('aria-expanded', String(!open));
      });
    });

    /* ---------------- start ---------------- */

    function syncTool() {
      paintCalibration();
      paintGauge();
      buildRuler();
      paintRuler();
    }

    syncTool();
    if (!state.calibrated) openCalibration();
    if (methodTabs.length) selectMethod(methodTabs[0].dataset.gaMethod);
    paintTables();

    window.addEventListener('resize', function () { paintRuler(); });
    if (window.visualViewport) {
      var previousZoom = window.visualViewport.scale;
      window.visualViewport.addEventListener('resize', function () {
        if (Math.abs(window.visualViewport.scale - previousZoom) < 0.01) return;
        previousZoom = window.visualViewport.scale;
        state.calibrated = false;
        try { window.localStorage.removeItem(STORAGE_KEY); } catch (e) {}
        paintCalibration();
      });
    }
    window.addEventListener('orientationchange', function () {
      state.calibrated = false;
      try { window.localStorage.removeItem(STORAGE_KEY); } catch (e) {}
      paintCalibration();
    });
  }

  function boot(scope) {
    var nodes = (scope || document).querySelectorAll('[data-ga-sizer]');
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    boot(ev.target);
  });
})();

